import Cookies from 'js-cookie';
import isbot from 'isbot';

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.site-notice:not([data-consent-notice])').forEach(notice => {

    const noticeId = notice.getAttribute('id');
    const expiresHours = notice.getAttribute('data-expires') ? parseFloat(notice.getAttribute('data-expires')) : 2;
    const expiresDays = expiresHours / 24;

    function init() {
      if (!isbot(navigator.userAgent)) {
        if (Cookies.get(noticeId) == undefined) {
          open();
        }
      }
    }

    function open() {
      notice.removeAttribute('hidden');
    }

    function close() {
      notice.setAttribute('hidden', 'true');
      Cookies.set(noticeId, 1, { expires: expiresDays });
    }

    if (notice.querySelector('.site-notice__close')) {
      notice.querySelector('.site-notice__close').addEventListener('click', (e) => {
        close();
      });
    }

    if (notice.querySelector('.site-notice__dismiss')) {
      notice.querySelector('.site-notice__dismiss').addEventListener('click', (e) => {
        close();
      });
    }

    init();


  });
});
